import React from "react";
import WebRTC from "ui/WebRTC";
import WebRTCStateProvider from "connectivity/WebRTCStateProvider";

const UIPeerStream = (props) => {
  const content = (
    <div className="UI-flexChild" id="UI-camera-container">
      <div className="UI-camera-box">
        <video className="UI-video" id="received_video" autoPlay></video>
        <video className="UI-video" id="local_video" autoPlay muted></video>
      </div>
      <WebRTCStateProvider>
        <WebRTC {...props} />
      </WebRTCStateProvider>
    </div>
  );

  return content;
};

export default React.memo(UIPeerStream, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
